import { z } from 'zod';
import { MoneySchema, PaginationParamsSchema, PaginationResponseSchema } from '../common';

/** Crew dashboard "My Jobs" tabs — mirrors host `GET /host/events?tab=`. */
export const VendorJobsTabSchema = z.enum([
  'APPLICATIONS',
  'UPCOMING',
  'LIVE',
  'COMPLETED',
  'JOB_INVITES',
]);

/**
 * Unified display status for the My Jobs table.
 * Mapped from IoI state (Applications) or booking state (other tabs).
 */
export const VendorJobRowStatusSchema = z.enum([
  'PENDING',
  'SHORTLISTED',
  'SELECTED',
  'WITHDRAWN',
  'REJECTED',
  'CANCELLED',
  'INVITED',
  'NEGOTIATING',
  'CONFIRMED',
  'LIVE',
  'COMPLETED',
  'DISPUTED',
]);

export const VendorJobRowKindSchema = z.enum(['IOI', 'BOOKING', 'ASSIGNMENT']);

/** `GET /marketplace/vendor/jobs` */
export const ListVendorJobsQuerySchema = z.object({
  tab: VendorJobsTabSchema,
  /** Case-insensitive match on event / job listing title */
  search: z.string().trim().min(2).max(100).optional(),
  ...PaginationParamsSchema.shape,
});

/** One row in the My Jobs table (Applications / Upcoming / Live / …). */
export const VendorJobRowSchema = z.object({
  id: z.uuid(),
  kind: VendorJobRowKindSchema,
  eventName: z.string(),
  date: z.string().nullable(),
  role: z.string(),
  payment: MoneySchema.nullable(),
  status: VendorJobRowStatusSchema,
  /** Raw IoI, booking, or assignment state for FE debugging / detail navigation */
  statusCode: z.string(),
  jobListingId: z.uuid().nullable(),
  bookingId: z.uuid().nullable(),
  ioiId: z.uuid().nullable(),
  eventId: z.uuid().nullable(),
  /** Present when kind=ASSIGNMENT */
  assignmentId: z.uuid().nullable().optional(),
});

export const VendorJobsTabResponseSchema = z.object({
  tab: VendorJobsTabSchema,
  items: z.array(VendorJobRowSchema),
  ...PaginationResponseSchema.shape,
});

/** `GET /marketplace/vendor/jobs/counts` — tab badge numbers */
export const VendorJobsTabCountsResponseSchema = z.object({
  applications: z.number().int().nonnegative(),
  upcoming: z.number().int().nonnegative(),
  live: z.number().int().nonnegative(),
  completed: z.number().int().nonnegative(),
  jobInvites: z.number().int().nonnegative(),
});
